'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonePaused = function MdPhonePaused(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 5h3.4v11.6h-3.4v-11.6z m1.8 20.9c0.9 0 1.6 0.7 1.6 1.6v5.9c0 0.9-0.7 1.6-1.6 1.6-15.7 0-28.4-12.7-28.4-28.4 0-0.9 0.7-1.6 1.6-1.6h5.9c0.9 0 1.6 0.7 1.6 1.6 0 2.2 0.4 4.1 1 6 0.1 0.5 0.1 1.2-0.4 1.7l-3.7 3.7c2.4 4.7 6.3 8.6 11 11l3.7-3.7c0.5-0.5 1.2-0.5 1.7-0.4 1.9 0.7 3.9 1 6 1z m-5-20.9v11.6h-3.4v-11.6h3.4z' })
        )
    );
};

exports.default = MdPhonePaused;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phone-paused.js
// module id = 1319
// module chunks = 36573943044255 79611799117203 213534597649335